import { afterNextRender, Component, DOCUMENT, inject, Injector } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, take } from 'rxjs';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `
    <div class="h-svh">
      <router-outlet></router-outlet>
    </div>
  `,
})
export class AppComponent {
  constructor() {
    const document = inject(DOCUMENT);
    const injector = inject(Injector);

    // Keep the static splash through initializers, lazy routes, and redirects.
    inject(Router)
      .events.pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        afterNextRender(
          () => {
            document.getElementById('startup-splash')?.remove();
            document.getElementById('startup-splash-styles')?.remove();
          },
          { injector },
        );
      });
  }
}
